import { createAsyncThunk } from '@reduxjs/toolkit';
import { SiteApi } from '../../api/SiteApi';
import {
  AppConfigCommon,
  CommonCustomisation,
  FooterCustomisation,
  SiteServer,
  SuppressionPageCustomisation
} from '../../components/common/CommonTypes';

export type SuppressionSiteServer = Partial<AppConfigCommon> & {
  brand?: SiteServer['brand'];
  content?: {
    header?: Pick<CommonCustomisation, 'faviconUrl' | 'navLogoUrl'>;
    footer?: FooterCustomisation;
    suppressionPage?: SuppressionPageCustomisation;
  };
};

export type SuppressionSiteServerResponse = {
  data: SuppressionSiteServer;
  error: string;
};

export const getSuppressionPageDetails = createAsyncThunk<
  SuppressionSiteServer,
  { countryCode?: string }
>(
  'site/getSuppressionPageDetails',
  async ({ countryCode }, { rejectWithValue, signal }) => {
    return await new Promise((resolve) => {
      new SiteApi().getSuppressionPageDetails(
        countryCode,
        ({ data, error }) => {
          if (error) {
            resolve(rejectWithValue(error));
          }
          if (data) {
            resolve(data);
          }
        },
        console.error,
        signal
      );
    });
  }
);
